import { useAuthStore } from '@/stores/auth'
import { useGeneralStore } from '@/stores/general'
import { useCompanyStore } from '@/stores/company'
import localStorageService from '@/core/localstorage.service'
import { langGuardGlobal } from '@/router/guards/lang.guard'
import { basicPages } from '@/core/config'

/* Auth & Route Guard access control - to prevent user for navigation to not-allowed routes */
export const globalBeforeEachGuard = async (to, from, next) => {
  const authStore = useAuthStore()
  const generalStore = useGeneralStore()
  const companyStore = useCompanyStore()
  const token = authStore.token

  /* Setting token when we redirect from old site */
  if (to.name === 'enter') {
    authStore.loginFromRedirect({
      token: to.query.token,
      managerId: to.query.managerId,
      adminToken: to.query.adminToken,
      investorId: Number(to.query.investor),
      referrer: to.query.referrer
    })

    return next({
      ...companyStore.baseRouteConfig,
      name: 'dashboard',
      params: { language: generalStore.currentLocale }
    })
  }

  /* removing the token from the localeStore when we go to the login page */
  if (to.name === 'login') {
    await authStore.logoutRedirect(next)
    return
  }

  /* in case manager want to access profile - redirect to different url */
  if (to.name === 'profile') {
    const managerId = localStorageService.getItem('managerId')
    const adminToken = localStorageService.getItem('adminToken')
    if (managerId && adminToken) {
      const redirectUrl = localStorageService.getItem('userFromRedirect') || process.env.VUE_APP_API
      authStore.removeToken()
      window.location.href = `${redirectUrl}/en/login_from_investor_portal?oneTimeToken=${adminToken}`
      return false
    }
  }

  /* mid-login: the session token isn't set yet, but getToken handed us one to
     verify against. Keyed off the store rather than from.name so it survives
     langGuardGlobal re-navigating by path on a locale switch. */
  if (!token && to.name === '2fa' && authStore.pendingToken) {
    return langGuardGlobal(to, from, next)
  }

  /* if there is no token in localStorage */
  if (!token && !basicPages.includes(to.name)) {
    return next({
      ...companyStore.baseRouteConfig,
      name: 'login',
      params: { language: generalStore.currentLocale, savedUrl: to.fullPath }
    })
  }

  return langGuardGlobal(to, from, next)
}
